import React from 'react';
import { Lock, X, Plus } from 'lucide-react';

const FormFieldList = ({
  customFields,
  newFieldValue,
  setNewFieldValue,
  onAddField,
  onRemoveField,
  fieldType,
  placeholder = "Add custom field",
  showNameEmail = true,
  variant = 'default'
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onAddField();
    }
  };

  if (variant === 'mobile-drawer') {
    return (
      <div className="space-y-2">
        {showNameEmail && (
          <div className="space-y-2">
            <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">First Name</span>
              <Lock className="w-3 h-3 text-stone-300" />
            </div>
            <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">Last Name</span>
              <Lock className="w-3 h-3 text-stone-300" />
            </div>
            <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">Email</span>
              <Lock className="w-3 h-3 text-stone-300" />
            </div>
            <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">Phone</span>
              <Lock className="w-3 h-3 text-stone-300" />
            </div>
            <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">Address</span>
              <Lock className="w-3 h-3 text-stone-300" />
            </div>
            <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">Interested Property</span>
              <Lock className="w-3 h-3 text-stone-300" />
            </div>
          </div>
        )}
        {customFields.map((field, index) => (
          <div key={index} className="flex items-center justify-between p-2.5 bg-white rounded border border-notion-border">
            <span className="text-xs text-stone-600">{typeof field === 'string' ? field : field.value}</span>
            <X className="w-3.5 h-3.5 text-stone-300 cursor-pointer hover:text-stone-500" onClick={() => onRemoveField(index, fieldType)} />
          </div>
        ))}
        <div className="flex gap-2">
          <input
            type="text"
            placeholder={placeholder}
            value={newFieldValue}
            onChange={(e) => setNewFieldValue(e.target.value)}
            onKeyDown={handleKeyDown}
            className="flex-1 bg-white border border-notion-border rounded-lg px-3 py-2 text-xs outline-none"
          />
          <button onClick={onAddField} className="px-3 py-2 bg-stone-200 rounded-lg text-xs font-medium text-stone-600">Add</button>
        </div>
      </div>
    );
  }

  if (variant === 'desktop-drawer') {
    return (
      <div>
        <h3 className="text-xs font-bold text-stone-400 uppercase tracking-wider mb-3">Capture Form Fields</h3>
        <div className="space-y-2 mb-3">
          <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
            <span className="text-xs text-stone-600 font-medium">First Name</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
          <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
            <span className="text-xs text-stone-600 font-medium">Last Name</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
          <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
            <span className="text-xs text-stone-600 font-medium">Email</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
          <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
            <span className="text-xs text-stone-600 font-medium">Phone</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
          <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
            <span className="text-xs text-stone-600 font-medium">Address</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
          <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
            <span className="text-xs text-stone-600 font-medium">Interested Property</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
          {customFields.map((field, index) => (
            <div key={index} className="flex items-center justify-between p-2.5 bg-white rounded border border-notion-border">
              <span className="text-xs text-stone-600">{typeof field === 'string' ? field : field.value}</span>
              <X className="w-3.5 h-3.5 text-stone-300 cursor-pointer hover:text-stone-500" onClick={() => onRemoveField(index, fieldType)} />
            </div>
          ))}
        </div>
        <div className="flex gap-2">
          <input
            type="text"
            placeholder={placeholder}
            value={newFieldValue}
            onChange={(e) => setNewFieldValue(e.target.value)}
            onKeyDown={handleKeyDown}
            className="flex-1 bg-white border border-notion-border rounded px-3 py-2 text-xs outline-none focus:border-stone-400"
          />
          <button onClick={onAddField} className="px-3 py-2 bg-stone-100 hover:bg-stone-200 rounded text-xs font-medium text-stone-600 transition">Add</button>
        </div>
      </div>
    );
  }

  if (variant === 'mobile-portfolio') {
    return (
      <>
        <div className="space-y-2 mb-3">
          <div className="space-y-2">
            <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">First Name</span>
              <div className="flex items-center gap-2">
                <span className="text-[10px] text-stone-400">Required</span>
                <Lock className="w-3 h-3 text-stone-300" />
              </div>
            </div>
            <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">Last Name</span>
              <div className="flex items-center gap-2">
                <span className="text-[10px] text-stone-400">Required</span>
                <Lock className="w-3 h-3 text-stone-300" />
              </div>
            </div>
            <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">Email</span>
              <div className="flex items-center gap-2">
                <span className="text-[10px] text-stone-400">Required</span>
                <Lock className="w-3 h-3 text-stone-300" />
              </div>
            </div>
            <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">Phone</span>
              <div className="flex items-center gap-2">
                <span className="text-[10px] text-stone-400">Required</span>
                <Lock className="w-3 h-3 text-stone-300" />
              </div>
            </div>
            <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">Address</span>
              <div className="flex items-center gap-2">
                <span className="text-[10px] text-stone-400">Required</span>
                <Lock className="w-3 h-3 text-stone-300" />
              </div>
            </div>
            <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
              <span className="text-xs text-stone-600 font-medium">Interested Property</span>
              <div className="flex items-center gap-2">
                <span className="text-[10px] text-stone-400">Required</span>
                <Lock className="w-3 h-3 text-stone-300" />
              </div>
            </div>
          </div>
          {customFields.map((field, index) => (
            <div key={index} className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
              <span className="text-xs text-stone-600">{typeof field === 'string' ? field : field.value}</span>
              <X className="w-3.5 h-3.5 text-stone-300 cursor-pointer hover:text-stone-500" onClick={() => onRemoveField(index, fieldType)} />
            </div>
          ))}
        </div>

        <div className="flex gap-2 mb-5">
          <input
            type="text"
            placeholder={placeholder}
            value={newFieldValue}
            onChange={(e) => setNewFieldValue(e.target.value)}
            onKeyDown={handleKeyDown}
            className="flex-1 bg-white border border-notion-border rounded px-3 py-2 text-xs outline-none focus:border-stone-400"
          />
          <button onClick={onAddField} className="px-3 py-2 bg-stone-100 rounded text-xs font-medium text-stone-600 hover:bg-stone-200 transition">
            <Plus className="w-4 h-4" />
          </button>
        </div>
      </>
    );
  }

  // Desktop portfolio variant (default)
  return (
    <>
      <div className="space-y-2 mb-4">
        <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
          <span className="text-xs text-stone-600 font-medium">First Name</span>
          <div className="flex items-center gap-2">
            <span className="text-[10px] text-stone-400">Required</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
        </div>
        <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
          <span className="text-xs text-stone-600 font-medium">Last Name</span>
          <div className="flex items-center gap-2">
            <span className="text-[10px] text-stone-400">Required</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
        </div>
        <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
          <span className="text-xs text-stone-600 font-medium">Email</span>
          <div className="flex items-center gap-2">
            <span className="text-[10px] text-stone-400">Required</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
        </div>
        <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
          <span className="text-xs text-stone-600 font-medium">Phone</span>
          <div className="flex items-center gap-2">
            <span className="text-[10px] text-stone-400">Required</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
        </div>
        <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
          <span className="text-xs text-stone-600 font-medium">Address</span>
          <div className="flex items-center gap-2">
            <span className="text-[10px] text-stone-400">Required</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
        </div>
        <div className="flex items-center justify-between p-2.5 bg-stone-50 rounded border border-notion-border">
          <span className="text-xs text-stone-600 font-medium">Interested Property</span>
          <div className="flex items-center gap-2">
            <span className="text-[10px] text-stone-400">Required</span>
            <Lock className="w-3 h-3 text-stone-300" />
          </div>
        </div>
        {customFields.map((field, index) => (
          <div key={index} className="flex items-center justify-between p-2.5 bg-white rounded border border-notion-border">
            <span className="text-xs text-stone-600">{typeof field === 'string' ? field : field.value}</span>
            <X className="w-3.5 h-3.5 text-stone-300 cursor-pointer hover:text-stone-500" onClick={() => onRemoveField(index, fieldType)} />
          </div>
        ))}
      </div>

      <div className="flex gap-2">
        <input
          type="text"
          placeholder={placeholder}
          value={newFieldValue}
          onChange={(e) => setNewFieldValue(e.target.value)}
          onKeyDown={handleKeyDown}
          className="flex-1 bg-white border border-notion-border rounded px-3 py-2 text-xs outline-none focus:border-stone-400"
        />
        <button onClick={onAddField} className="px-3 py-2 bg-stone-100 hover:bg-stone-200 rounded text-xs font-medium text-stone-600 transition">Add Field</button>
      </div>
    </>
  );
};

export default FormFieldList;
